import { LESSON_STATUS } from '@yandex-int/k-common/typings';

// eslint-disable-next-line complexity
export const getLessonStatusKey = (status: LESSON_STATUS, isCopying: boolean = false): string => {
    if (isCopying) {
        return 'lesson.lessonStatus.copying';
    }

    switch (status) {
        case LESSON_STATUS.NOT_ASSIGNED:
            return 'lessons.lessonStatus.notAssigned';
        case LESSON_STATUS.ASSIGNED:
            return 'lessons.lessonStatus.assigned';
        case LESSON_STATUS.ASSIGNED_IN_FUTURE:
            return 'lessons.lessonStatus.assignedInFuture';
        case LESSON_STATUS.IN_PROGRESS:
            return 'lessons.lessonStatus.inProgress';
        case LESSON_STATUS.FINISHED:
            return 'lessons.lessonStatus.finished';
        case LESSON_STATUS.NOT_SOLVED:
            return 'lessons.lessonStatus.notSolved';
        case LESSON_STATUS.FINISH_FORCED:
            return 'lessons.lessonStatus.finishForced';
        case LESSON_STATUS.WAIT_FOR_RESULTS:
            return 'lessons.lessonStatus.waitForResults';
        case LESSON_STATUS.CANCELLED:
            return 'lessons.lessonStatus.cancelled';
        default:
            console.error(`Не поддерживается статус урока ${status}`);

            return 'lessons.lessonStatus.notAssigned';
    }
};

export const getCalendarLessonStatusKey = (status: LESSON_STATUS) => {
    switch (status) {
        case LESSON_STATUS.NOT_ASSIGNED:
            return 'lessons.calendar.lessonStatus.notAssigned';
        case LESSON_STATUS.ASSIGNED_IN_FUTURE:
            return 'lessons.calendar.lessonStatus.assignedInFuture';
        case LESSON_STATUS.ASSIGNED:
        case LESSON_STATUS.IN_PROGRESS:
            return 'lessons.calendar.lessonStatus.assigned';
        case LESSON_STATUS.FINISHED:
            return 'lessons.calendar.lessonStatus.finished';
        default:
            console.error(`Не поддерживается статус урока для календаря ${status}, используй getCalendarLessonStatus`);

            return 'lessons.lessonStatus.notAssigned';
    }
};
